/** Locale copy and labels for the Prashna client.
 *
 * Split out of `PrashnaClient.tsx` on 2026-08-18: that file stood at 514 lines
 * against the 500-line ceiling (G03) and was failing CI on `main`. The copy
 * table and its derived label helper carry no component logic, so they lift out
 * without touching behaviour.
 */

export const PRASHNA_COPY = {
  en: {
    questionLabel: "Your Question",
    questionPlaceholder: "e.g. Will I get the job offer this month?",
    locationLabel: "Your Current Location",
    locationPlaceholder: "Search city...",
    locationHint: "Chart is cast for where you are right now, not your birth place.",
    submitLabel: "Cast Prashna Kundali",
    calculating: "Casting chart…",
    lagnaLabel: "Prashna Lagna",
    horaLabel: "Hora Lord",
    significatorLabel: "Ruling Planets",
    moonLabel: "Moon Rashi",
    confidenceLabel: "Confidence",
    summaryLabel: "Interpretation",
    houseAnalysisLabel: "House Analysis",
    followUpHeadline: "Still turning the same question over?",
    followUpSubhead: "Take this answer to Pandit-ji and keep asking in your own words.",
    followUpCta: "Continue this question",
    editQuestion: "Edit your question",
  },
  hi: {
    questionLabel: "आपका प्रश्न",
    questionPlaceholder: "उदाहरण: क्या मुझे इस महीने नौकरी मिलेगी?",
    locationLabel: "आपका वर्तमान स्थान",
    locationPlaceholder: "शहर खोजें...",
    locationHint: "प्रश्न का चार्ट आपके वर्तमान स्थान से बनता है, जन्म स्थान से नहीं।",
    submitLabel: "प्रश्न कुंडली बनाएं",
    calculating: "गणना हो रही है...",
    lagnaLabel: "प्रश्न लग्न",
    horaLabel: "होरा लॉर्ड",
    significatorLabel: "रूलिंग ग्रह",
    moonLabel: "चंद्र राशि",
    confidenceLabel: "विश्वास स्तर",
    summaryLabel: "व्याख्या",
    houseAnalysisLabel: "भाव विश्लेषण",
    followUpHeadline: "इसी प्रश्न पर और पूछना है?",
    followUpSubhead: "यही उत्तर लेकर पंडित जी से अपने शब्दों में बात जारी रखें।",
    followUpCta: "प्रश्न जारी रखें",
    editQuestion: "प्रश्न बदलें",
  },
} as const;

export function prashnaLabels(isHi: boolean) {
  return PRASHNA_COPY[isHi ? "hi" : "en"];
}

export type PrashnaLabels = ReturnType<typeof prashnaLabels>;
